import React from 'react';
import { Badge, Avatar } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const CartBadge = ({ cartItemList }) => {
  const navigate = useNavigate();

  const badgeNuber = cartItemList.reduce((acc, item) => {
    return acc + item.sellToBuyerQty.qty;
  }, 0);

  return (
    <Badge
      badgeContent={badgeNuber}
      color='error'
      overlap='circular'
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      sx={{
        '.MuiBadge-dot': {
          top: 5,
        },
      }}
    >
      <Avatar
        onClick={() => {
          if (cartItemList.length === 0)
            return toast.error('Please add products to cart');
          navigate('/fmcg/buyer-cart');
        }}
        sx={{
          cursor: 'pointer',
          width: 56,
          height: 56,
          color: 'white',
          backgroundColor: 'rgba(244, 157, 63,1)',
        }}
      >
        <ShoppingCartIcon />
      </Avatar>
    </Badge>
  );
};

export default CartBadge;
